const deleteEquipmentModelsStr = {
  toastr: 'Tipo de equipo eliminado',
  toastr1: ' eliminado con éxito'
};

export default deleteEquipmentModelsStr;
